var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataphoneLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73682 23.8563H0V2.55326C0 1.19428 1.11314 0.0859375 2.478 0.0859375H4.73682V23.8563ZM4.73682 26.8762H0V29.1186C0 30.4776 1.11314 31.5859 2.478 31.5859H4.73682V26.8762ZM12.1895 31.5859H7.45272V7.81559H12.1895V31.5859ZM12.1895 0.0859375H7.45272V4.79565H12.1895V0.0859375ZM14.9786 7.8402C19.6518 7.8402 23.4416 11.4208 23.4416 15.8359C23.4416 20.251 19.6518 23.8317 14.9786 23.8317L14.9054 23.8309V19.659L14.9786 19.6601C17.2134 19.6601 19.0262 17.9474 19.0262 15.8359C19.0262 13.7245 17.2134 12.0118 14.9786 12.0118L14.9054 12.0128V7.84093L14.9786 7.8402ZM14.9786 0.0859375C24.1844 0.0859375 31.6487 7.13838 31.6487 15.8359C31.6487 24.5335 24.1844 31.5859 14.9786 31.5859L14.9054 31.5849V26.8791L14.9786 26.8797C21.4338 26.8797 26.6676 21.9345 26.6676 15.8359C26.6676 9.73735 21.4338 4.79214 14.9786 4.79214L14.9054 4.79282V0.0869856L14.9786 0.0859375Z",
    fill: "url(#paint0_linear_1886_4043)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1886_4043",
    x1: 2.99306,
    y1: 31.0706,
    x2: 29.6025,
    y2: 4.50227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A96AFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45098,
    stopColor: "#5732FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08DEBA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataphoneLogoIcon);
export default __webpack_public_path__ + "static/media/dataphone-logo-icon.23ec41af63e3214bc48ff329d2449b07.svg";
export { ForwardRef as ReactComponent };